import React, { useEffect, useState } from "react";
import { DatabaseZap, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { apiClient, formatApiError } from "@/lib/auth";

export default function SnapshotImportCard() {
  const [d, setD] = useState(null);
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => apiClient.get("/admin/snapshot").then((r) => setD(r.data)).catch(() => setD(null));
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!d?.running) return undefined;
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, [d?.running]);
  if (!d) return null;
  const go = async () => {
    setBusy(true);
    try { await apiClient.post("/admin/snapshot/import", { confirm }); toast.success("Import started"); setConfirm(""); load(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const residents = d.snapshot?.counts?.re_residents;
  const last = d.last_import;
  return (
    <div className="card-industrial corner-tick p-8 md:p-10 mb-6" data-testid="snapshot-import-card">
      <div className="flex items-center gap-3 mb-2">
        <DatabaseZap className="text-nex-gold" size={22} />
        <div className="mono-label">// BRING OVER PREVIEW DATA</div>
      </div>
      {!d.snapshot ? <p className="text-nex-chrome" data-testid="snapshot-none">No preview data package is waiting.</p> : (
        <>
          <p className="text-nex-chrome mb-4" data-testid="snapshot-info">
            Package from {new Date(d.snapshot.created_at).toLocaleString()} · {residents ?? 0} residents. Copies every resident, finance and document record into this site.
            Nothing here is deleted; staff keep the password and PIN they use on this site.
          </p>
          {last && <p className="text-sm mb-4" data-testid="snapshot-last">Last import: <b className="text-nex-silver" data-testid="snapshot-status">{last.status}</b>{last.status === "running" && last.progress && ` · part ${last.progress}`}
            {last.counts?.re_residents != null && ` · ${last.counts.re_residents} residents`}{last.counts?.error && ` · ${last.counts.error}`}</p>}
          <div className="flex flex-wrap gap-2">
            <input data-testid="snapshot-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Type IMPORT"
              className="bg-black/40 border border-white/15 px-3 py-2 text-sm text-white" />
            <button type="button" data-testid="snapshot-import-btn" disabled={confirm !== "IMPORT" || busy || d.running} onClick={go}
              className="tick-btn-primary !py-2 !px-4 text-xs inline-flex items-center gap-2 disabled:opacity-40">
              {(busy || d.running) && <Loader2 className="h-3.5 w-3.5 animate-spin" />}{d.running ? "Importing…" : "Import now"}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
